import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'
import { media } from 'utils/media'
import { Avatar } from 'lib/Avatar'
import { Text } from 'lib/Text'
import { useCurrentBrand } from './context/CurrentBrandProvider'

const Container = styled.div`
  margin: 24px 0;
  padding: 16px;
  border: var(--border);
  border-color: var(--neutral-20);
  column-gap: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  ${media.tabletDown} {
    padding: 16px 24px;
  }
`

const SpotterWrapper = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
  cursor: pointer;
  text-decoration: none;
`

const Name = styled(Text)`
  &:hover {
    color: var(--neutral-100);
  }
`

export const SpottedBy = () => {
  const { brand } = useCurrentBrand()

  if (!brand.addedBy?.fullName) {
    return null
  }

  const { avatarFullPath, username, fullName } = brand.addedBy

  return (
    <Container>
      <Text weight="medium" size="ps" color="neutral-100">
        Spotted by
      </Text>
      <Link legacyBehavior href={`/${username}/reviews`} passHref prefetch={false}>
        <SpotterWrapper>
          {avatarFullPath && <Avatar size="small" user={{ avatarFullPath, username, fullName }} />}
          <Name weight="medium" size="ps" color="neutral-60">
            {fullName}
          </Name>
        </SpotterWrapper>
      </Link>
    </Container>
  )
}
